import React from 'react';
import { BarChart } from 'lucide-react';

export default function ProgressChart({ data }) {
  const total = data.reduce((sum, item) => sum + item.count, 0);
  if (total === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <BarChart size={32} className="mx-auto mb-2 text-gray-300" />
        <p>No data available</p>
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {data.map((item, index) => {
        const percentage = (item.count / total) * 100;
        return (
          <div key={index} className="flex items-center">
            <div className="w-20 text-sm font-medium text-gray-700">{item.label}</div>
            <div className="flex-1 mx-3">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div className={`h-2 rounded-full ${item.color}`} style={{ width: `${percentage}%` }} />
              </div>
            </div>
            <div className="w-12 text-sm text-gray-600 text-right">{item.count}</div>
          </div>
        );
      })}
    </div>
  );
}
